import {
  ADD_GAME_TO_CART,
  ADD_GAME_TO_USER,
  ADD_GAME_TO_USER_FAV,
  FETCH_GAMES,
  IS_GAME_IN_CART,
  REMOVE_GAME_FROM_CART,
  REMOVE_GAME_FROM_USER_FAV,
} from "../actions/types";

const initialState = {
  games: null,
  addGameToUser: null,
  addGameToUserFav: null,
  loading: false,
  bought: false,
};

export default function gameReducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case "BOUGHT_GAME":
      return {
        ...state,
        bought: true,
      };
    case "BOUGHT_GAME_END":
      return {
        ...state,
        bought: false,
      };
    case "ACTION_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ACTION_REQUEST_END":
      return {
        ...state,
        loading: false,
      };
    case FETCH_GAMES:
      return {
        ...state,
        games: payload,
      };
    case ADD_GAME_TO_CART: {
      let obj = JSON.parse(localStorage.getItem("cart"));
      if (obj == null) {
        obj = [];
      }
      let exist = obj.find((item) => item == payload);
      if (!exist) obj.push(payload);
      localStorage.setItem("cart", JSON.stringify(obj));
      return {
        ...state,
      };
    }
    case REMOVE_GAME_FROM_CART:
      let obj = JSON.parse(localStorage.getItem("cart"));
      obj = obj.filter((item) => item != payload);
      localStorage.setItem("cart", JSON.stringify(obj));
      return {
        ...state,
      };
    case ADD_GAME_TO_USER:
      if (payload != -1) {
        let cart = JSON.parse(localStorage.getItem("cart"));
        let user = JSON.parse(localStorage.getItem("user_info"));
        for (let cartItem of cart) user.my_games.push(cartItem);
        localStorage.setItem("user_info", JSON.stringify(user));
        localStorage.removeItem("cart");
      }
      return {
        ...state,
        addGameToUser: payload,
      };
    case ADD_GAME_TO_USER_FAV:
      if (payload != -1) {
        let user = JSON.parse(localStorage.getItem("user_info"));
        if (user.my_favourites == null) {
          user.my_favourites = [];
        }
        let obj = user.my_favourites.find((fav) => fav == payload);
        if (!obj) user.my_favourites.push(payload);
        localStorage.setItem("user_info", JSON.stringify(user));
      }
      return {
        ...state,
        addGameToUserFav: payload,
      };
    case REMOVE_GAME_FROM_USER_FAV:
      if (payload != -1) {
        let user = JSON.parse(localStorage.getItem("user_info"));
        if (user.my_favourites == null) {
          user.my_favourites = [];
        }
        user.my_favourites = user.my_favourites.filter((fav) => fav != payload);
        localStorage.setItem("user_info", JSON.stringify(user));
      }
      return {
        ...state,
        addGameToUserFav: payload,
      };
    default:
      return {
        ...state,
      };
  }
}
